import { asyncAll } from './util';
import { Actor } from './actor';
/**
 * Responsible for sending messages from a {@link Source} to an associated
 * {@link WorkerSource}.
 */
export class Dispatcher {
    constructor(workerPool, parent, mapId) {
        this.workerPool = workerPool;
        this.actors = [];
        this.currentActor = 0;
        this.id = mapId;
        const workers = this.workerPool.acquire(mapId);
        for (let i = 0; i < workers.length; i++) {
            const worker = workers[i];
            const actor = new Dispatcher.Actor(worker, parent, mapId);
            actor.name = `Worker ${i}`;
            this.actors.push(actor);
        }
        if (!this.actors.length)
            throw new Error('No actors found');
    }
    /**
     * Broadcast a message to all Workers.
     */
    broadcast(type, data, cb) {
        cb = cb || function () { };
        asyncAll(this.actors, (actor, done) => {
            actor.send(type, data, done);
        }, cb);
    }
    /**
     * Acquires an actor to dispatch messages to. The actors are distributed in round-robin fashion.
     * @returns An actor object backed by a web worker for processing messages.
     */
    getActor() {
        this.currentActor = (this.currentActor + 1) % this.actors.length;
        return this.actors[this.currentActor];
    }
    remove(mapRemoved = true) {
        this.actors.forEach((actor) => { actor.remove(); });
        this.actors = [];
        if (mapRemoved)
            this.workerPool.release(this.id);
    }
}
Dispatcher.Actor = Actor;
//# sourceMappingURL=dispatcher.js.map